// extracted by mini-css-extract-plugin
module.exports = {"root":"LazyFileItem_root__1s6GE","selected":"LazyFileItem_selected__3GH-m","hover":"LazyFileItem_hover__2m86o"};